exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".responsive[data-v-42979f31]{max-width:100%;height:auto}", ""]);

// exports
